import { gql } from "@apollo/client";

export const QUERY_FORM3457N_VERSION = gql`
  query studentForm3457N(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457N(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      communicationType
      communicationDate
      programDate
      documentContactName
      documentContactPhone
      districtRepresentativeName
      districtRepresentativeTitle
      formAction
      formStatus
    }
  }
`;
